export function awaiter<
  T extends ((() => Promise<unknown>) | Promise<unknown>)[],
>(...params: T) {
  return Promise.all(
    params.map((v) => (typeof v === "function" ? v() : v)),
  ) as Promise<{
    [P in keyof T]: Awaited<
      T[P] extends () => Promise<infer R>
        ? R
        : T[P] extends Promise<infer R>
          ? R
          : never
    >;
  }>;
}
